import { Button } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { EvaluationSteps } from '~valuation/enums';
import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';
import PropertyType from '~valuation/pages/AddValuation/PropertyDetailsStep/PropertyType';
import PropertyView from '~valuation/pages/AddValuation/PropertyDetailsStep/PropertyView';
import FinishType from '~valuation/pages/AddValuation/PropertyDetailsStep/FinishType';
import Area from '~valuation/pages/AddValuation/PropertyDetailsStep/Area';
import Rooms from '~valuation/pages/AddValuation/PropertyDetailsStep/Rooms';
import Bathroom from '~valuation/pages/AddValuation/PropertyDetailsStep/Bathroom';
import { useTranslation } from 'react-i18next';

const PropertyDetailsStep = ({
  setActiveStep,
  formSchemaData,
}: {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  formSchemaData?: any;
}) => {
  const { t } = useTranslation('app');
  const { watch, trigger, setError } = useFormContext();
  const valuationType = watch('type');

  const handleNext = async () => {
    const keys =
      valuationType === ValuationTypeEnum.PORTFOLIO
        ? [
            'propertyType',
            'propertyView',
            'finishType',
            'area',
            'rooms',
            'baths',
          ]
        : ['propertyType'];
    const valid = await trigger(keys);

    if (valid)
      valuationType === ValuationTypeEnum.PORTFOLIO
        ? setActiveStep(EvaluationSteps.PROPERTY_PRICE)
        : setActiveStep(EvaluationSteps.DATA_ANALYSIS);
    else {
      keys.map((key) => {
        if (!watch(key)) setError(key, { type: 'manual' });
      });
    }
  };

  return (
    <div className="flex flex-col gap-3x md:gap-5x">
      <div className="flex flex-col gap-3x px-2x md:px-0">
        <p className="text-lg text-title_3 text-black">
          {t('propertyDetailsEnter')}
        </p>
        <div className="flex flex-col gap-3x">
          <PropertyType />
          {valuationType === ValuationTypeEnum.PORTFOLIO && (
            <div className="flex flex-col gap-4x">
              <PropertyView formSchemaData={formSchemaData} />
              <FinishType formSchemaData={formSchemaData} />
              <div className="flex flex-col md:flex-row justify-between gap-4x">
                <Area />
                <Rooms />
                <Bathroom />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-center pt-3x px-2x md:px-3x border-t border-gray w-full gap-1.5x md:gap-5x">
        <Button
          variant="primary"
          size="medium"
          className="text-link w-full max-w-[271px]"
          onClick={() => handleNext()}
        >
          {t('next')}{' '}
        </Button>
        <Button
          variant="secondary"
          size="medium"
          className="text-link w-full max-w-[271px]"
          onClick={() => setActiveStep(EvaluationSteps.LOCATION)}
        >
          {t('back')}{' '}
        </Button>
      </div>
    </div>
  );
};

export default PropertyDetailsStep;
